import React from 'react';

/**
 * Tubelight flicker reveal (pure CSS keyframes injected once).
 * Wrap any inline text; it flickers on then stays lit.
 * Ported from Breww landing.
 *
 * Props:
 *   delay  — seconds before flicker starts
 *   run    — when true, animation plays; when false, hidden (opacity 0)
 */
const STYLE_ID = 'esg-flicker-style';
const ensureStyle = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = `
    @keyframes esg-tubelight {
      0%, 12%, 18%, 26%, 34%, 46%, 58%, 74%, 92%, 100% { opacity: 1; filter: drop-shadow(0 0 12px currentColor); }
      6%, 15%, 22%, 30%, 40%, 52%, 66%, 82% { opacity: 0.1; filter: none; }
      3%, 9%, 20%, 28%, 36%, 48%, 60%, 76% { opacity: 0.55; }
    }
    .esg-flicker-hidden { opacity: 0; }
    .esg-flicker-run { animation: esg-tubelight 1.6s steps(60, end) forwards; }
    @media (prefers-reduced-motion: reduce) {
      .esg-flicker-run { animation: none; opacity: 1; }
      .esg-flicker-hidden { opacity: 1; }
    }
  `;
  document.head.appendChild(s);
};

const FlickerReveal = ({ children, delay = 0, run = true, as: Tag = 'span', className = '', style = {} }) => {
  ensureStyle();
  return (
    <Tag
      className={`${run ? 'esg-flicker-run' : 'esg-flicker-hidden'} ${className}`}
      style={{ animationDelay: `${delay}s`, display: 'inline-block', ...style }}
    >
      {children}
    </Tag>
  );
};

export default FlickerReveal;
